<app-background-image-container [tintMode]="tintMode" [backgroundImage]="backgroundImage">
  <div class="intro-text">
    @if (title) {
      <h1>{{ title }}</h1>
    }
    @if (subTitle) {
      <h3>{{ subTitle }}</h3>
    }
  </div>

  <div class="logo-card-container">
    <mat-card appearance="outlined" class="logo-card" [ngStyle]="{ maxWidth: cardWidth }">
      <mat-card-header>
        <img class="vanhu-tech-logo" src="/images/vanhu-tech-logo.svg" alt="Logo" />
      </mat-card-header>
      @if (isLoading) {
        <mat-card-content>
          <span><i>Loading...</i></span>
        </mat-card-content>
      } @else if (hasError) {
        <mat-card-content>
          <div class="error-and-try-again">
            <mat-error
              >Something went wrong. Please
              <a href="#" (click)="this.handleRetryClick($event)">try again</a>
              in a few moments. If the problem persists, please send an email to
              <a href="mailto:info@vanhu-tech.org">info&#64;vanhutech.org</a>.
            </mat-error>
          </div>
        </mat-card-content>
      } @else {
        <mat-card-content>
          <ng-content select="[cardContent]"></ng-content>
        </mat-card-content>
        <mat-card-actions>
          <ng-content select="[cardActions]"></ng-content>
        </mat-card-actions>
      }
    </mat-card>
  </div>
</app-background-image-container>
